// Скелет списка в форме таблицы (045: OPN-21; research Р9) — «Контроль» и вкладки «Справочника»,
// когда строк ещё нет. Первые 0,3 с ожидания (shown = false) — только место под скелет, без рамки
// и полос: рамки таблицы без строк нет, высота не прыгает. Дальше рамка встаёт сразу со строками
// скелета (у загрузки DataTable рамка 0,3 с стояла пустой). Когда ждать, решает страница
// (useDelayedFlag): после смены вкладки она уже подождала — скелет сразу.
// Форма — шапка таблицы и пять строк списка с полосами ячеек (Skeleton/README.md «Табеля»).
import { SkeletonBar, cx } from '@kp/ui';
import './table-skeleton.css';

/** Ширины полос ячеек строки: первая колонка, текст, значение справа. */
const CELLS = ['28%', '36%', '14%'] as const;
const ROWS = 5;

export function TableSkeleton({
  shown = true,
  className,
}: {
  shown?: boolean;
  className?: string;
}) {
  if (!shown) {
    return (
      <div role="status" aria-busy="true" aria-label="Загрузка…" className="kp-table-sk-wait" />
    );
  }
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Загрузка…"
      className={cx('t-card kp-table kp-table-sk', className)}
    >
      <div className="t-row kp-table-sk-head" aria-hidden="true">
        {CELLS.map((width, index) => (
          <SkeletonBar
            key={width}
            width={`calc(${width} / 2)`}
            height={8}
            className={cx(index === CELLS.length - 1 && 'kp-sk-end')}
          />
        ))}
      </div>
      {Array.from({ length: ROWS }, (_, row) => (
        <div key={row} className="t-row kp-sk-row kp-table-sk-row" aria-hidden="true">
          {CELLS.map((width, index) => (
            <SkeletonBar
              key={width}
              width={width}
              height={10}
              className={cx(index === CELLS.length - 1 && 'kp-sk-end')}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
